import type { PlatformProductCategory, UnitCode } from '~/graphql/graphql';
import { useGetUserPreferences } from '~/api/auth';

type UnitFilter = { category: PlatformProductCategory; unit: UnitCode };

export function resolvePreferredUnit(
  filters: readonly UnitFilter[] | null | undefined,
  category: PlatformProductCategory | null | undefined,
  fallback: UnitCode
): UnitCode {
  if (!filters || !category) return fallback;
  return filters.find((f) => f.category === category)?.unit ?? fallback;
}

export function usePreferredUnit(
  category: PlatformProductCategory | null | undefined,
  fallback: UnitCode
): UnitCode {
  const { data } = useGetUserPreferences();
  return resolvePreferredUnit(
    data?.userPreferences?.productPreferredUnitFilters,
    category,
    fallback
  );
}
